import React, {useContext, useMemo, useState} from 'react';
import {shopContext} from '../../../contexts/ShopContext';
import {trackEvent} from '../../../utils/Analytics';
import UI from './ui.web';

const CatalogProductCard = ({product, ...props}) => {
  const [productQty, setProductQty] = useState(1);

  const ShopC = useContext(shopContext);

  const isFree = useMemo(() => {
    return !(product.price > 0);
  }, [product]);

  const networkImage = useMemo(() => {
    return (
      product.images && product.images.length > 0 && product.images[0].imageUrl
    );
  }, [product]);

  const updateProductQty = qty => {
    if (qty > 0) setProductQty(qty);
  };

  const onPressAddToCart = () => {
    trackEvent('Add to Cart', {productid: product.id});

    let cartItems = [...ShopC.cartProducts];
    let index = 0;
    let inCart = false;
    if (cartItems.length > 0) {
      cartItems.forEach((i, idx) => {
        if (i.id == product.id) {
          index = idx;
          inCart = true;
        }
      });
    }

    if (inCart) {
      const p = cartItems[index];
      const productDetails = {...p, productQty: p.productQty + productQty};
      cartItems[index] = productDetails;
      ShopC.setCartProducts(cartItems);
    } else {
      const productDetails = {...product, productQty};
      cartItems.push(productDetails);
      ShopC.setCartProducts(cartItems);
    }
  };

  const uiProps = {
    product,
    isFree,
    networkImage,
    productQty,
    onPressAddToCart,
    updateProductQty,
    ...props,
  };

  return <UI {...uiProps} />;
};

export default CatalogProductCard;
